import { jsx as M } from "react/jsx-runtime";
import { BadRequest as P } from "@systemeio/util";
import { useStore as g } from "../../../../store/index.mjs";
import { useStripeApi as x } from "../../api/stripe-api.mjs";
import { getStripeCardConfirmHandler as b } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStripe as k, useElements as q, ExpressCheckoutElement as O } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as R } from "@systemeio/ui";
import { useRollbar as B } from "@rollbar/react";
import { getStripeCardRequestOptions as F } from "../utils/get-stripe-card-request-options.mjs";
function J({
  setIsFetching: a,
  handleBadRequest: f,
  setErrors: c,
  preSubmit: l
}) {
  const r = k(), t = q(), u = B(), { locale: y } = g(), { stripeCardBuyOffer: d, confirmPaymentIntent: h } = x();
  return /* @__PURE__ */ M(
    O,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: async (o) => {
        if (!(!r || !t)) {
          a(!0);
          try {
            const e = l();
            if (!e) return;
            const { error: C } = await t.submit();
            if (C) {
              o.paymentFailed();
              return;
            }
            const { error: w, paymentMethod: n } = await r.createPaymentMethod({
              elements: t
            });
            if (w || !n) {
              o.paymentFailed();
              return;
            }
            const { redirect: i, intentSecret: m, intentType: E } = await d(
              {
                ...e,
                paymentMethod: R.stripe_applepay,
                options: F(n)
              },
              y
            );
            if (!m) return window.location.href = i;
            const S = b(r, E), { error: s } = await S(m, {
              payment_method: n.id
            });
            s ? c((p) => ({
              ...p,
              common: [...p.common, s.message]
            })) : (await h(), window.location.assign(i));
          } catch (e) {
            try {
              o.paymentFailed({ reason: "fail" });
            } catch {
            }
            e instanceof P ? f(e) : u.error("Stripe Express Checkout Confirmation Error", { error: e });
          } finally {
            a(!1);
          }
        }
      }
    }
  );
}
export {
  J as StripeExpressCheckout
};
